import {
  Loader,
  Point,
  TilingSprite,
  WRAP_MODES,
} from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import vars from '../vars';
import Actor from './Actor';

class Table extends Actor {
  constructor(parent) {
    super(parent);

    const tableClothTexture = Loader.shared.resources['textures/TABLE_CLOTH'].texture;
    tableClothTexture.baseTexture.wrapMode = WRAP_MODES.MIRRORED_REPEAT;
    this.sprite = new TilingSprite(
      tableClothTexture,
      vars.layout.FRAME_WIDTH,
      vars.layout.FRAME_HEIGHT,
    );

    this.frameHandler = () => { this.frame(); };

    this.resize();
    this.parent.addChild(this.sprite);
  }

  resize() {
    this.sprite.position = new Point(0, 0);
  }

  startMove() {
    ticker.add(this.frameHandler);
  }

  frame() {
    this.sprite.tilePosition.y -= state.speed * ticker.speed;
  }

  gameover() {
    ticker.remove(this.frameHandler);
  }
}

export default Table;
